import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  debugMacro: {
    border: '2px solid red',
    overflow: 'auto',
  },
  gridItemWrapper: {
    width: 236,
    marginTop: 10,
  },
};

export default function DebugInfo({ data }) {
  return (
    <div style={styles.debugMacro}>
      <pre>{JSON.stringify(data, null, 2).replace(/\\n/g, '\n')}</pre>
    </div>
  );
}

export const GridItemDebugInfo = (props) => (
  <div style={styles.gridItemWrapper}>
    <DebugInfo {...props} />
  </div>
);

DebugInfo.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.array,
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
};
